import React from "react";
import { TextField, InputAdornment, Box } from "@mui/material";
import SearchIcon from "assets/images/icons/search.svg";

const SearchInput = ({
	placeholder = "Enter here",
	value = "",
	onChange = () => {},
	...rest
}: {
	placeholder?: string;
	value?: string;
	onChange?: (e: any) => void;
	rest?: any;
}) => {
	return (
		<TextField
			placeholder={placeholder}
			value={value}
			onChange={onChange}
			variant="outlined"
			fullWidth
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<Box
							component="img"
							src={SearchIcon}
							sx={{
								height: "16px",
								width: "16px",
							}}
						/>
					</InputAdornment>
				),
				className: "!border-gray-400",
			}}
			className="!w-auto !min-w-72 rounded-lg !border-gray-500"
			// sx={{
			// 	"& .MuiOutlinedInput-root": {
			// 		"& fieldset": {
			// 			borderColor: "gray", // Tailwind: border-gray-300
			// 		},
			// 		"&:hover fieldset": {
			// 			borderColor: "gray", // Tailwind: border-gray-400
			// 		},
			// 		"&.Mui-focused fieldset": {
			// 			borderColor: "gray", // Tailwind: border-gray-500
			// 		},
			// 	},
			// }}
			{...rest}
		/>
	);
};

export default SearchInput;
